"use strict";function openModal$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.openModal$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.openModal";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.pc]={vs:"2.5.0"},_a)),exports.openModal$=openModal$,exports.default=openModal$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/openModal.js
// module id = 1016
// module chunks = 106